module.exports = __webpack_public_path__ + "img/icon_sy_ysrz@2x.af4a1001.png";